import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { baseURL, endPoints } from "utils/constants";
import { parseData } from "utils/helpers";

const { userEndPoint, companyEndPoint } = endPoints;

export const ApiClient = axios.create({
  baseURL: baseURL,
  // baseURL: "http://62.72.51.210:1234/",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
  },
  // withCredentials: true,
  timeout: 30000,
});

ApiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const userData = parseData(localStorage.getItem("user-detail"));

    // console.log({ userData });

    // const username = localStorage.getItem("username");

    if (userData?.token && config.headers) {
      // config.headers.Authorization = `Bearer ${token}`;
      config.headers.Authorization = `ApiKey ${userData?.username}:${userData?.token}`;
      // config.headers[userData?.username] = `${userData?.token}`;
    }
    // const csrftoken = document.cookie
    //   .split("; ")
    //   .find((row) => row.startsWith("csrftoken="))
    //   ?.split("=")[1];

    // if (csrftoken) {
    //   config.headers["X-CSRFToken"] = csrftoken;
    // }
    return config;
  },

  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  },
);

ApiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError): Promise<AxiosError> => {
    if (error.response) {
      if (error?.config?.url === `${userEndPoint}/login/`) {
        return Promise.reject(error);
      }

      // console.log({ error });

      const isCompanyInvalid =
        error?.config?.url?.includes(companyEndPoint) &&
        error.response.status !== 200;

      if (error.response.status === 401 || isCompanyInvalid) {
        const userData = parseData(localStorage.getItem("user-detail"));
        if (userData) {
          localStorage.removeItem("user-detail");
        }
        // handle unauthorized error
        // redirect to login
        if (window?.location?.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }

    return Promise.reject(error);
  },
);
